var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerticalFullBrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 425.98 268.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 204.13,
    y1: -2.34,
    x2: 208.55,
    y2: 242.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2328eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2342eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2360eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2373eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#237aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2391eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#23caeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#23cceb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 199.87,
    y1: 124.46,
    x2: 219.64,
    y2: -62.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2328eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#232aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2332eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2340eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2353eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#236beb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#237aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#23cceb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 137.19,
    y1: 108.8,
    x2: 135.9,
    y2: 36.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2328eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23cceb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 184.92,
    y1: 109.34,
    x2: 183.63,
    y2: 36.76,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 232.21,
    y1: 109.8,
    x2: 230.92,
    y2: 37.23,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 279.32,
    y1: 109.6,
    x2: 278.03,
    y2: 37.02,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.18,22.72H163.49c-21.16,0-38.31,16.62-38.31,37.12v64.67c0,20.5,17.15,37.11,38.31,37.11,0,0,3.87.08,5,.57,5.34,2.38,2.78,22.18,7.12,24.68a1.66,1.66,0,0,0,1.89-.18c3.44-2.91,20.12-24.4,27.12-24.69,4.95-.19,43.56,0,43.56,0,21.16,0,38.34-17,38.34-37.49V59.84C286.49,39.34,269.34,22.72,248.18,22.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.94,55l-32-48.62A12.89,12.89,0,0,0,258.82,0H153.62a10.49,10.49,0,0,0-9.07,5.28L112.47,55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.48,54.77c0,.06,0,.12,0,.18,0,13.57,10.64,24.57,23.76,24.57S160,68.52,160,55c0-.06,0-.12,0-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.2,54.77c0,.06,0,.12,0,.18,0,13.57,10.64,24.57,23.76,24.57s23.76-11,23.76-24.57v-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M207.72,54.77c0,.06,0,.12,0,.18,0,13.57,10.54,24.57,23.53,24.57s23.53-11,23.53-24.57c0-.06,0-.12,0-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.78,54.77c0,.06,0,.12,0,.18,0,13.57,10.56,24.57,23.59,24.57s23.58-11,23.58-24.57c0-.06,0-.12,0-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M206.9,121.33c-11.64,0-22.4-1-31.12-8-1.16-.94-2.38,1.14-1.52,2.59,7.47,12.65,19,22,31.89,22,13.19,0,24.83-9.36,32.24-22.83.43-.77,0-2.88-.65-2.4C229.09,119.45,218.35,121.33,206.9,121.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.45,216v41.41h-10.1v-3q-3,3.51-8.87,3.51a15.08,15.08,0,0,1-7.54-1.92,14,14,0,0,1-5.38-5.5,16.74,16.74,0,0,1-2-8.26,16.57,16.57,0,0,1,2-8.23,13.76,13.76,0,0,1,5.38-5.45,15.26,15.26,0,0,1,7.54-1.89q5.42,0,8.37,3.12V216Zm-12.22,31.56a7.53,7.53,0,0,0,1.79-5.33,7.45,7.45,0,0,0-1.76-5.25,5.93,5.93,0,0,0-4.55-1.89,6,6,0,0,0-4.58,1.89,7.37,7.37,0,0,0-1.78,5.25,7.53,7.53,0,0,0,1.78,5.33,6,6,0,0,0,4.58,1.92A5.91,5.91,0,0,0,248.23,247.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.49,226.67H274.1v30.75H263.49Zm10.61-8.49a5.39,5.39,0,1,1-5.39-5.38A5.39,5.39,0,0,1,274.1,218.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.44,226.78V251.9q0,8.41-4.57,12.64t-13.17,4.21a33.59,33.59,0,0,1-8.38-1,19.85,19.85,0,0,1-6.64-3l3.85-7.42a13.7,13.7,0,0,0,4.66,2.37,19.09,19.09,0,0,0,5.56.86c2.79,0,4.83-.61,6.14-1.84a7.18,7.18,0,0,0,1.95-5.47v-1q-3.07,3.57-9,3.57a15.52,15.52,0,0,1-7.42-1.82,13.75,13.75,0,0,1-5.41-5.13,15.54,15.54,0,0,1,0-15.29,13.78,13.78,0,0,1,5.41-5.14,15.51,15.51,0,0,1,7.42-1.81q6.48,0,9.49,4.18v-4.07ZM299.08,245.7a6.27,6.27,0,0,0,0-8.9,6.69,6.69,0,0,0-4.74-1.7,6.81,6.81,0,0,0-4.78,1.7,6.2,6.2,0,0,0,0,8.9,6.81,6.81,0,0,0,4.75,1.73A6.69,6.69,0,0,0,299.08,245.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.58,226.67h10.6v30.75h-10.6Zm10.68-8.43a5.39,5.39,0,1,1-5.38-5.39A5.39,5.39,0,0,1,325.26,218.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,257.27a30.39,30.39,0,0,1-5.25.65q-5.93,0-9.1-2.9c-2.12-1.93-3.18-4.82-3.18-8.65V236.21H328v-7.92h4.41v-7.87H343v7.87H350v7.92H343v10a3.56,3.56,0,0,0,.87,2.54,3,3,0,0,0,2.32.92,7.47,7.47,0,0,0,3.74-1.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.52,230.1q4,3.43,4,10.52v16.8H371.6v-3.91q-2.28,4.41-8.93,4.41a14.09,14.09,0,0,1-6.08-1.22,9.06,9.06,0,0,1-3.88-3.33,8.8,8.8,0,0,1-1.31-4.77,7.76,7.76,0,0,1,3.29-6.67q3.3-2.37,10.16-2.37h6q-.28-4.8-6.42-4.8a14.59,14.59,0,0,0-4.41.7,11.9,11.9,0,0,0-3.8,1.92l-3.57-7.2a19.89,19.89,0,0,1,6.11-2.59,28.79,28.79,0,0,1,7.23-.92Q373.57,226.67,377.52,230.1Zm-8.65,20.23a5,5,0,0,0,2-2.62v-2.62H366.3q-4.64,0-4.63,3.07a2.69,2.69,0,0,0,1.06,2.23,4.55,4.55,0,0,0,2.9.84A5.84,5.84,0,0,0,368.87,250.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.11,226.78h10.6v30.64h-10.6Zm10.69-8.54a5.39,5.39,0,1,1-5.39-5.39A5.39,5.39,0,0,1,394.8,218.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.54,257.06a19.78,19.78,0,0,1-5.91-2.26l3.18-7.26a17.65,17.65,0,0,0,4.91,2,22.09,22.09,0,0,0,5.64.75,8.87,8.87,0,0,0,3.65-.53,1.65,1.65,0,0,0,1.09-1.53c0-.67-.44-1.15-1.31-1.43a28.66,28.66,0,0,0-4.16-.8,40.67,40.67,0,0,1-6.17-1.18,9.45,9.45,0,0,1-4.38-2.68,7.64,7.64,0,0,1-1.84-5.47,8.3,8.3,0,0,1,1.73-5.16,11.41,11.41,0,0,1,5-3.57,21.55,21.55,0,0,1,8-1.31,32,32,0,0,1,6.53.67,18.88,18.88,0,0,1,5.41,1.89l-3.18,7.2A17.73,17.73,0,0,0,413,234.2a8.67,8.67,0,0,0-3.68.59,1.75,1.75,0,0,0-1.18,1.53c0,.71.43,1.2,1.29,1.48a29.32,29.32,0,0,0,4.24.87,47.4,47.4,0,0,1,6.2,1.28,9.6,9.6,0,0,1,4.27,2.65A7.56,7.56,0,0,1,426,248a8.22,8.22,0,0,1-1.73,5.11,11.35,11.35,0,0,1-5.11,3.54,22.8,22.8,0,0,1-8.12,1.28A33,33,0,0,1,403.54,257.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.76,227.27v26.32q0,7.62-3.73,11.3t-11.25,3.68a25,25,0,0,1-7.89-1.23A16.06,16.06,0,0,1,1.82,264l2.05-3.07a15.52,15.52,0,0,0,5.27,3A19.73,19.73,0,0,0,15.66,265q5.7,0,8.38-2.65t2.67-8.23v-3.82a12.1,12.1,0,0,1-4.92,4.33A15.25,15.25,0,0,1,15,256.09a15.84,15.84,0,0,1-7.66-1.85A13.56,13.56,0,0,1,2,249.06,15.4,15.4,0,0,1,2,234a13.46,13.46,0,0,1,5.38-5.12A16,16,0,0,1,15,227.05a15.26,15.26,0,0,1,6.89,1.53A12.42,12.42,0,0,1,26.88,233v-5.76ZM21.3,251.11a10,10,0,0,0,4.07-3.9,11.14,11.14,0,0,0,1.46-5.7,11,11,0,0,0-1.46-5.66,10.07,10.07,0,0,0-4-3.88,12.23,12.23,0,0,0-5.89-1.39,12.3,12.3,0,0,0-5.84,1.36,10,10,0,0,0-4,3.88,11.91,11.91,0,0,0,0,11.39,10.14,10.14,0,0,0,4.05,3.9,12.09,12.09,0,0,0,5.84,1.39A12.28,12.28,0,0,0,21.3,251.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.19,243.51H38.12a10.71,10.71,0,0,0,3.59,7.54,11.91,11.91,0,0,0,8.2,2.88,12.86,12.86,0,0,0,5.13-1,11.11,11.11,0,0,0,4-2.93l2.28,2.62a13,13,0,0,1-5,3.65,17,17,0,0,1-6.58,1.25,16.6,16.6,0,0,1-8.17-2,14.12,14.12,0,0,1-5.56-5.44,15.46,15.46,0,0,1-2-7.86A16.1,16.1,0,0,1,36,234.39,13.84,13.84,0,0,1,41.23,229a14.64,14.64,0,0,1,7.49-1.93A14.48,14.48,0,0,1,56.18,229a13.75,13.75,0,0,1,5.18,5.38,16.15,16.15,0,0,1,1.88,7.89ZM41.46,233.28a10.89,10.89,0,0,0-3.34,7.21H59.37A10.93,10.93,0,0,0,56,233.28a10.28,10.28,0,0,0-7.32-2.76A10.17,10.17,0,0,0,41.46,233.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.13,228.58a14.46,14.46,0,0,1,7-1.53V231l-1-.05a9.6,9.6,0,0,0-7.41,2.9c-1.78,1.94-2.68,4.65-2.68,8.15v15.26H66v-30h3.87v5.87A9.86,9.86,0,0,1,74.13,228.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.8,243.51H86.73a10.71,10.71,0,0,0,3.59,7.54,11.92,11.92,0,0,0,8.21,2.88,12.81,12.81,0,0,0,5.12-1,11.15,11.15,0,0,0,4-2.93l2.27,2.62a13,13,0,0,1-5,3.65,17,17,0,0,1-6.58,1.25,16.63,16.63,0,0,1-8.17-2,14,14,0,0,1-5.55-5.44,15.47,15.47,0,0,1-2-7.86,16.1,16.1,0,0,1,1.91-7.86A13.84,13.84,0,0,1,89.84,229a14.64,14.64,0,0,1,7.49-1.93,14.48,14.48,0,0,1,7.46,1.93,13.75,13.75,0,0,1,5.18,5.38,16.15,16.15,0,0,1,1.88,7.89ZM90.07,233.28a10.89,10.89,0,0,0-3.34,7.21H108a10.88,10.88,0,0,0-3.33-7.21,10.28,10.28,0,0,0-7.32-2.76A10.17,10.17,0,0,0,90.07,233.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.16,230.32q3.33,3.27,3.33,9.54v17.37h-4v-17c0-3.11-.78-5.49-2.34-7.12a8.76,8.76,0,0,0-6.66-2.45,10.22,10.22,0,0,0-7.66,2.88c-1.88,1.92-2.82,4.56-2.82,7.94v15.72h-4v-30h3.88v5.53a11.26,11.26,0,0,1,4.58-4.25,14.79,14.79,0,0,1,6.81-1.5A12.25,12.25,0,0,1,139.16,230.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.53,255.41a7.71,7.71,0,0,1-2.82,1.57,11.38,11.38,0,0,1-3.5.54,8.8,8.8,0,0,1-6.5-2.28,8.69,8.69,0,0,1-2.27-6.44V230.69h-5.36v-3.42h5.36v-6.55h4v6.55h9.11v3.42h-9.11v17.89a5.67,5.67,0,0,0,1.34,4.07,5.06,5.06,0,0,0,3.84,1.39,7.31,7.31,0,0,0,2.42-.4,5.85,5.85,0,0,0,2-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.22,243.51H170.16a10.67,10.67,0,0,0,3.59,7.54,11.9,11.9,0,0,0,8.2,2.88,12.86,12.86,0,0,0,5.13-1,11.2,11.2,0,0,0,4-2.93l2.28,2.62a13,13,0,0,1-5,3.65,17,17,0,0,1-6.58,1.25,16.64,16.64,0,0,1-8.18-2,14.16,14.16,0,0,1-5.55-5.44,15.46,15.46,0,0,1-2-7.86,16.09,16.09,0,0,1,1.9-7.86,13.91,13.91,0,0,1,5.24-5.41,15.46,15.46,0,0,1,15,0,13.75,13.75,0,0,1,5.18,5.38,16.26,16.26,0,0,1,1.88,7.89Zm-21.73-10.23a10.88,10.88,0,0,0-3.33,7.21H191.4a10.84,10.84,0,0,0-3.33-7.21,11,11,0,0,0-14.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.66,256.46a14.92,14.92,0,0,1-5.21-2.65l1.83-3.18a15.49,15.49,0,0,0,4.72,2.42,19,19,0,0,0,5.93.94q4.09,0,6.06-1.29a4.07,4.07,0,0,0,2-3.61,3.24,3.24,0,0,0-1.08-2.59,7.21,7.21,0,0,0-2.74-1.43,41,41,0,0,0-4.38-.94,50.27,50.27,0,0,1-5.87-1.39,8.7,8.7,0,0,1-3.79-2.42,6.76,6.76,0,0,1-1.56-4.73,7.39,7.39,0,0,1,3.13-6.15c2.09-1.6,5-2.39,8.71-2.39a22.67,22.67,0,0,1,5.81.76,16.13,16.13,0,0,1,4.79,2l-1.77,3.24a15.11,15.11,0,0,0-8.83-2.56,10.12,10.12,0,0,0-5.83,1.37,4.18,4.18,0,0,0-2,3.58,3.55,3.55,0,0,0,1.11,2.74,6.84,6.84,0,0,0,2.76,1.51c1.1.32,2.62.65,4.56,1a52.53,52.53,0,0,1,5.75,1.36,8.43,8.43,0,0,1,3.7,2.34A6.4,6.4,0,0,1,223,249a7.26,7.26,0,0,1-3.27,6.24c-2.19,1.54-5.21,2.31-9.09,2.31A22.83,22.83,0,0,1,203.66,256.46Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalFullBrand);
export default __webpack_public_path__ + "static/media/vertical_full-brand.9ca1343cd6135020cd3669da0c8fa09e.svg";
export { ForwardRef as ReactComponent };